<template>
  <div class="customer-list salaryCalculationList clearfix">
    <Search
      @getHeight="getHeight"
      @saveSet="saveSet"
      :tableConfig="tableConfig"
      :tableName="tableName"
      :functionBtn="activeName == 0 || activeName == 9"
      ref="Search"
      :isquery="true"
      :isDel="false"
      :isSort="false"
      :isAdd="false"
      :showDel="false"
      :showSort="false"
      :showAdd="false"
      searchName="SalaryGrantPage"
    >
      <template v-slot:left>
        <el-col :lg="24" :md="24" :sm="24" :xs="24">
          <el-form-item label="关键字" prop="keyWord">
            <el-input
              @keyup.enter.native="$refs.Search.handleSearch"
              v-model="searchForm.keyWord"
              clearable
              placeholder="请输入关键字查询"
            ></el-input>
          </el-form-item>
        </el-col>
      </template>
      <template v-slot:center>
        <el-button
          size="small "
          type="success"
          plain
          v-if="
            (activeName == 0 || activeName == 5 || activeName == 9) &&
            verifyPermission('Add')
          "
          @click="importExport"
          icon="el-icon-caret-right"
          >开始直发</el-button
        >
        <!-- <el-button
              size="small "
              type="success"
              plain
              @click="$router.push('/payingUnit')"
              icon="el-icon-upload"
              v-if="verifyPermission('UnitMaintain')"
              >发薪单位维护</el-button
            > -->
      </template>
      <template v-slot:advancedQuery>
        <el-col :lg="8" :md="10" :sm="12" :xs="24">
          <el-form-item label="创建时间">
            <el-col :span="11">
              <el-date-picker
                style="width: 100%"
                v-model="searchForm.stateDate"
                value-format="yyyy-MM-dd"
                type="date"
                placeholder="选择开始日期"
              >
              </el-date-picker>
            </el-col>
            <el-col :span="2">~</el-col>

            <el-col :span="11">
              <el-date-picker
                style="width: 100%"
                v-model="searchForm.endDate"
                value-format="yyyy-MM-dd"
                type="date"
                placeholder="选择结束日期"
              >
              </el-date-picker>
            </el-col>
          </el-form-item>
        </el-col>
        <el-col :lg="4" :md="8" :sm="12" :xs="24">
          <el-form-item
            label-width="100px"
            label="发薪单位"
            prop="isCooperation"
          >
            <el-select
              v-model="searchForm.payUnitId"
              clearable
              placeholder="请选择发薪单位"
              @clear="clear"
            >
              <el-option
                v-for="item in payUnitList"
                :key="item.id"
                :label="item.name"
                :value="item.id"
              ></el-option>
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :lg="4" :md="6" :sm="12" :xs="24">
          <el-form-item label="单位">
            <el-select
              filterable
              v-model="searchForm.employingUnitId"
              clearable
              style="width: 100%"
              placeholder="请选择单位"
            >
              <el-option
                v-for="item in companyList"
                :key="item.Id"
                :label="item.customerName"
                :value="item.id"
              ></el-option>
            </el-select>
          </el-form-item>
        </el-col>
      </template>
    </Search>
    <div class="customer-table-list fr page" style="padding: 0">
      <el-tabs
        v-model="activeName"
        type="border-card"
        @tab-click="handleClick"
        tab-position="left"
      >
        <el-tab-pane label="全部" name="9"></el-tab-pane>
        <el-tab-pane label="待提交" name="0"></el-tab-pane>
        <el-tab-pane label="待复核" name="1"></el-tab-pane>
        <el-tab-pane label="待付款" name="3"></el-tab-pane>
        <el-tab-pane label="已完成" name="5"></el-tab-pane>

        <MyTable
          @sortChange="sortChange"
          :tableData="tableData"
          :tableConfig="tableConfig"
          :height="tableHeight"
          :width="'width: calc(100% - 92px)'"
          :indexFlag="true"
          @EmptyBtn="importExport"
          tableEmptyText="暂无数据，请引入工资条"
        >
          <template v-slot:index="slotData">
            {{
              ($refs.pagination.currentPage - 1) * $refs.pagination.pageSize +
              slotData.scope.$index +
              1
            }}
          </template>
          <template v-slot:payRollName="slotData">
            {{
              slotData.scope.row.wageTitle ? slotData.scope.row.wageTitle : "-"
            }}
          </template>
          <template v-slot:createDate="slotData">
            {{
              slotData.scope.row.createDate &&
              slotData.scope.row.createDate.slice(0, 16)
            }}
          </template>
          <template v-slot:payment="slotData">
            {{
              slotData.scope.row.payment == 1
                ? "代发"
                : slotData.scope.row.payment == 2
                ? "网银转账"
                : "-"
            }}
          </template>
          <template v-slot:totalMoney="slotData">
            {{ parseFloat(slotData.scope.row.totalMoney).toFixed(2) }}
          </template>
          <template v-slot:state="slotData">
            <el-tag
              size="small"
              type="info"
              v-if="slotData.scope.row.state == 0"
              >待提交</el-tag
            >
            <el-tag size="small" v-if="slotData.scope.row.state == 1"
              >待复核</el-tag
            >
            <el-tag
              size="small"
              type="danger"
              v-if="slotData.scope.row.state == 2"
              >未通过复核</el-tag
            >
            <el-tag
              size="small"
              type="info"
              v-if="slotData.scope.row.state == 4"
              >已发放</el-tag
            >
            <el-tag
              size="small"
              type="warning"
              v-if="slotData.scope.row.state == 3"
              >待付款</el-tag
            >
            <el-tag
              size="small"
              type="warning"
              v-if="slotData.scope.row.state == 8"
              >待付款 (发放中)</el-tag
            >
            <el-tag
              size="small"
              type="success"
              v-if="slotData.scope.row.state == 5"
              >已完成</el-tag
            >

            <el-tag
              size="small"
              type="danger"
              v-if="
                slotData.scope.row.state == 7 || slotData.scope.row.state == 6
              "
              >已完成(异常)</el-tag
            >
          </template>
          <template v-slot:baseOperation="slotData">
            <el-button
              @click="navDetail(slotData.scope.row)"
              plain
              size="small"
              icon="el-icon-edit"
              v-if="verifyPermission('Update')"
              >{{ btnLabel(slotData.scope.row.state) }}</el-button
            >
            <el-button
              @click="deleteCustomer(slotData.scope.row.id)"
              type="danger"
              plain
              size="small"
              v-if="slotData.scope.row.state == 0 && verifyPermission('Delete')"
              icon="el-icon-delete"
              >删除</el-button
            >
          </template>
          <template v-slot:moreOperation="slotData">
            <el-button
              @click="down"
              type="primary"
              plain
              size="small"
              v-if="slotData.scope.row.state == 5 && verifyPermission('Select')"
              icon="el-icon-download"
              >生产凭证汇总</el-button
            >
          </template>
        </MyTable>
      </el-tabs>
      <Pagination
        class="PagPosition"
        :total="total"
        @getNewData="SalaryGrantPage"
        ref="pagination"
      />
    </div>
    <!-- <AddCustomer
      :drawerShow="addCustomerDrawerShow"
      :title="drawerTitle"
      :operation="operation"
      :customerInfo="customerInfo"
      :industryData="industryData"
      :users="users"
      @colseDrawer="addCustomerDrawerShow = false"
      @refreshData="
        () => {
          SalaryGrantPage();
          // getCustomerLevelClassData();
        }
      "
    /> -->
    <incomingData
      @colseDrawer="colseDrawer"
      :visible.sync="incomingDataShow"
      @update="
        (val) => {
          if (val == false) {
            SalaryGrantPage();
          }
        }
      "
    />
  </div>
</template>

<script>
import MyTable from "@/components/Table";
import Search from "@/components/Search";
import { verifyPermissionMinix } from "@/utils/mixin";
import incomingData from "./incomingData";

export default {
  components: {
    MyTable,
    Search,
    incomingData,
  },
  mixins: [verifyPermissionMinix],

  data() {
    return {
      tableHeight: "",
      form: {},
      submitLoading: false,
      selectloading: false,
      incomingDataShow: false,
      confirmationVisible: false,
      tableName: "salaryBehalf",
      tableConfig: [
        {
          field: "createDate",
          label: "创建时间",
          slotName: "createDate",
          width: 180,
          flag: true,
          align: "center",
        },
        {
          field: "projectName",
          label: "项目名称",
          align: "center",
          minWidth: 200,

          flag: true,
        },
        {
          field: "payRollName",
          label: "工资条名称",
          align: "center",
          slotName: "payRollName",
          minWidth: 200,
          flag: true,
        },
        {
          field: "payUnitName",
          label: "发薪单位",
          align: "center",
          width: 190,
          flag: true,
        },

        {
          field: "employingUnit",
          label: "单位",
          align: "center",
          minWidth: "180",
          flag: true,
        },
        {
          field: "payment",
          label: "发薪方式",
          slotName: "payment",
          align: "center",
          flag: true,
          minWidth: "100",
        },
        {
          field: "state",
          label: "状态",
          align: "center",
          minWidth: "130",

          slotName: "state",
          flag: true,
        },
        {
          field: "totalCount",
          label: "发放人数",
          align: "center",
          minWidth: "100",
          flag: true,
        },
        {
          field: "totalMoney",
          label: "发放总额",
          flag: true,
          minWidth: "100",
          slotName: "totalMoney",
          align: "right",
        },
        {
          field: "createUserName",
          label: "制单操作员",
          align: "center",
          minWidth: "180",

          flag: true,
        },
        {
          field: "createDate",
          label: "制单操作时间",
          align: "center",
          minWidth: "180",

          flag: true,
        },
        {
          field: "auditUserName",

          label: "复核操作员",
          align: "center",
          minWidth: "180",

          flag: true,
        },
        {
          field: "auditDate",

          label: "复核操作时间",
          align: "center",
          minWidth: "180",

          flag: true,
        },
        {
          field: "payUserName",
          label: "发放操作员",
          align: "center",
          minWidth: "180",

          flag: true,
        },
        {
          field: "payDate",
          label: "发放操作时间",
          align: "center",
          minWidth: "180",

          flag: true,
        },
        {
          label: "基本操作",
          slotName: "baseOperation",
          width: 200,
          align: "left",
          flag: true,
          fixed: "right",
        },
        // {
        //   label: "更多操作",
        //   slotName: "moreOperation",
        //   width: 150,
        //   align: "center",
        //   flag: true,
        //   fixed: "right",
        // },
      ],
      tabList: [],
      tableData2: [],
      tabIndex: 0,
      addCustomerDrawerShow: false,
      drawerTitle: "",
      total: 0,
      loading: false,
      tableData: [],
      companyList: [],
      searchForm: {},
      customerIds: [],
      customerInfo: null,
      operation: "",
      companyId: "",
      searchList: [],
      industryData: [],
      payUnitList: [],
      activeName: "9",
      tableId: "",
      exportBtnIsDisabled: false,
      rules2: {
        materialState: [
          { required: true, message: "请选择状态", trigger: "blur" },
        ],
      },
    };
  },
  computed: {},
  mounted() {
    this.getCompanyList();
    this.getPayrollUnitList();
    // this.SalaryGrantPage();
    // document.addEventListener("visibilitychange", this.visibilityState);
    if (localStorage.getItem(this.tableName)) {
      this.tableConfig = JSON.parse(localStorage.getItem(this.tableName));
      this.sortType = this.tableConfig.pop();
      this.tableConfig.forEach((element) => {
        if (element.sortable) {
          element.sortable = type;
        }
      });
    }
  },
  activated() {
    this.SalaryGrantPage();
  },
  // beforeDestroy() {
  //   document.removeEventListener("visibilitychange", this.visibilityState); //移除监听
  // },
  methods: {
    btnLabel(state) {
      switch (state) {
        case 0:
          return "去提交";
        case 1:
          return "去复核";
        case 2:
          return "去详情";
        case 3:
          return "去付款";
        case 4:
          return "去详情";
        case 5:
          return "去详情";
        case 6:
          return "去查看";
        case 7:
          return "去查看";
        case 8:
          return "去查看";
      }
    },
    down() {},
    getPayrollUnitList() {
      this.$api.customer.PayrollUnitPage().then((res) => {
        if (res.error === false) {
          this.payUnitList = res.data.data;
          if (res.data.data.length <= 0 || res.data.data == null) {
            // this.unitTip();
          }
        } else {
          this.$message.error(res.msg);
        }
      });
    },
    unitTip() {
      this.$confirm("暂无发薪单位,请前往发薪单位处新增发薪单位", "提示", {
        confirmButtonText: "前往发薪单位",
        cancelButtonText: "关 闭",
        type: "warning",
      })
        .then(() => {
          this.$router.push("/payingUnit");
        })
        .catch(() => {});
    },
    colseDrawer() {
      this.incomingDataShow = false;
    },
    visibilityState(e) {
      let visibilityState = e.target.visibilityState;
      switch (visibilityState) {
        case "visible": //显示
          this.SalaryGrantPage();
          console.log(1);
          break;
        case "hidden": //隐藏
          console.log(2);
          break;
        default:
      }
    },

    // 跳转详情
    navDetail(row) {
      this.$router.push({
        path: "/salaryBehalfDetail",
        query: {
          active: this.activeName,
          id: row.id,
          salaryId: row.salaryId,
        },
      });
      // const routeUrl = this.$router.resolve({
      //   path: "/salaryBehalfDetail",
      //   query: {
      //     active: this.activeName,
      //     id: row.id,
      //     salaryId: row.salaryId,
      //   },
      // });

      // window.open(routeUrl.href, "_blank");
    },

    // 导入表格
    importExport() {
      this.incomingDataShow = true;
    },
    sortChange(column) {
      if (this.sortType == "custom") {
      }
    },
    handleSearch() {},
    // 导入工时表

    // 列的显示与隐藏
    saveSet(checkList, type) {
      if (checkList) {
        this.sortType = type;

        this.tableConfig = JSON.parse(JSON.stringify(checkList));
        this.tableConfig.forEach((element) => {
          if (element.sortable) {
            element.sortable = type;
          }
        });

        this.$forceUpdate();
      }
    },
    getHeight(height) {
      let newHeight = height.replace("px", "");
      this.tableHeight = newHeight + "px";
    },
    confirmation(id) {
      this.tableId = id;
      this.confirmationVisible = true;
    },
    handleClick() {
      this.$refs.pagination.currentPage = 1;
      this.$refs.pagination.pageSize = 20;
      this.SalaryGrantPage();
      this.$forceUpdate();
    },
    clear() {
      this.searchForm.isCooperation = undefined;
    },
    getCompanyList() {
      this.$api.customer.getAllCustomerList().then((res) => {
        // console.log(res);
        if (res.error === false) {
          this.companyList = res.data;
        }
      });
    },
    resetForm() {
      this.customerIds = [];
      this.modify = false;
      this.form = {};
      this.$refs.form.clearValidate();
      this.searchList = [];
    },
    //获取数据
    SalaryGrantPage() {
      this.loading = true;
      let Data = "";
      let sendData = {};
      sendData = {
        pageIndex: this.$refs.pagination.currentPage,
        pageSize: this.$refs.pagination.pageSize,
        keyWord: this.searchForm.keyWord,
        stateDate: this.searchForm.stateDate,
        endDate: this.searchForm.endDate,
        employingUnitId: this.searchForm.employingUnitId,
        payUnitId: this.searchForm.payUnitId,
      };
      if (this.activeName != 9) {
        sendData.stateStringList = this.activeName;
        if (this.activeName == 5) {
          sendData.stateStringList = "5,7,6";
        }
        if (this.activeName == 3) {
          sendData.stateStringList = "3,8";
        }
      }
      // console.log(this.searchForm);
      // Data = {
      //   keyWord: this.searchForm.keyWord,
      //   state: this.searchForm.state,
      //   customerId: this.searchForm.companyId,
      //   startDate: this.searchForm.startDate,
      //   endDate: this.searchForm.endDate,
      // };
      // // console.log(sendData);
      // for (let i in Data) {
      //   if (Data[i] != undefined) {
      //     sendData[i] = Data[i];
      //   }
      // }
      this.$api.salary.SalaryGrantPage(sendData).then((res) => {
        if (res.error === false) {
          this.loading = false;
          this.tableData = res.data.data;
          this.total = res.data.count;
        } else {
          this.$message.error(res.msg);
        }
      });
    },

    // 删除公司
    deleteCustomer(ids) {
      this.$confirm("是否删除？", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          let sendData = new FormData();
          sendData.append("id", ids);
          this.$api.salary.SalaryGrantDelete(sendData).then((res) => {
            if (res.error === false) {
              this.$message.success("删除成功");
              this.SalaryGrantPage();
            } else {
              this.$message.error(res.msg);
            }
          });
        })
        .catch(() => {});
    },
  },
};
</script>
<style lang="less" >
.customer-list {
  .upload-demo {
    .el-upload {
      width: 100% !important;
    }
    .el-upload-dragger {
      width: 100% !important;
    }
  }
}
// .salaryCalculationList {
//   .el-form-item {
//     margin-bottom: 0px !important;
//   }
// }
</style>
<style lang="less" scoped>
// .el-form-item__label {
//   width: 60px !important;
// }

.customer-list {
  .file,
  .table {
    width: 100%;
    .title {
      display: flex;
      align-items: center;
      .num {
        color: rgb(26, 210, 103);
        font-size: 22px;
        margin-right: 15px;
      }
    }

    .upload-demo {
      width: 100%;
      padding: 10px 70px;
      .el-upload-dragger {
        width: 100% !important;
      }
    }
    .result {
      padding: 10px 70px;
    }
  }
}
.btn {
  margin-left: 15px;
}
</style>
